import React from 'react';
import SvgIcon from '@/components/Icon/SvgIcon';
import { Badge } from '@/components/ui/badge';
import { MerchantOrderStatusEnum } from '@/graphql/generatedTypes';
import { cn } from '@/lib/utils';
import i18n from '@/utils/i18n';
import {
  StatusPresets,
  getPresetKeyForStatus,
  StatusVariant,
} from './orderStatusConfig';
import { IconName } from '@/utils/iconName';

export type OrderStatusBadgeProps = {
  expired?: boolean;
  status?: MerchantOrderStatusEnum;
  className?: string;
  /** 'client' for customer-facing (default), 'admin' for admin view */
  variant?: StatusVariant;
};

function getStatusIcon(iconName: string) {
  return <SvgIcon name={iconName as IconName} className="tw:size-[15px]" />;
}

export default function OrderStatusBadge({
  expired = false,
  status = MerchantOrderStatusEnum.OnHold,
  className,
  variant = 'client',
}: OrderStatusBadgeProps) {
  let presetKey = getPresetKeyForStatus(status, variant);
  // If the status is open, show as expired
  if (expired && presetKey === 'open') {
    presetKey = 'expired';
  }

  const preset = StatusPresets[presetKey] ?? StatusPresets.open;

  return (
    <Badge
      variant="default"
      className={cn(
        'tw:min-h-6 tw:rounded-lg tw:px-2 tw:py-[3px] tw:text-xs tw:font-medium tw:shadow-none tw:gap-1.5 tw:cursor-default',
        preset.className,
        className,
      )}
    >
      <span className={cn('tw:flex tw:items-center tw:gap-1.5 tw:text-nowrap')}>
        {getStatusIcon(preset.iconName)}
        {i18n.t(preset.labelKey)}
      </span>
    </Badge>
  );
}
